import LoadingComponent from "../../components/common/LoadingComponent";
import MultiSelect from "../../components/common/MultiSelect";
import { PLATFORMS } from "../../constants/constants";
import Select from "react-select";
import { NON_ARRAY_FIELDS } from "./PlatformWorkspace.utils";

export function OptionList({ options, selectedId, onSelect, emptyMessage, disabled }) {
  if (!options.length) {
    return (
      <p
        className="text-center py-3 mb-0"
        style={{ color: "rgba(255,255,255,0.3)", fontSize: 14 }}
      >
        {emptyMessage || "No options available."}
      </p>
    );
  }

  return (
    <div className="ws-option-list">
      {options.map((option) => {
        const isSelected =
          selectedId !== undefined &&
          selectedId !== null &&
          String(option.id).trim() === String(selectedId).trim();

        return (
          <div
            key={option.id}
            className={`ws-option-item${isSelected ? " selected" : ""}`}
            onClick={() => !disabled && onSelect(String(option.id))}
            style={disabled ? { cursor: "not-allowed", opacity: 0.6 } : {}}
          >
            <div className="ws-option-radio" />
            <span className="ws-option-label">{option.label}</span>
            <span className="ws-check">✓</span>
          </div>
        );
      })}
    </div>
  );
}

export function Stepper({ steps, currentStep }) {
  return (
    <div className="ws-stepper">
      {steps.map((step, index) => {
        const stepState =
          index < currentStep ? "completed" : index === currentStep ? "active" : "";

        return (
          <div key={index} className={`ws-step ${stepState}`}>
            <div className="ws-step-circle">
              {stepState === "completed" ? "✓" : index + 1}
            </div>
            <span className="ws-step-label">{step.label}</span>
          </div>
        );
      })}
    </div>
  );
}

export function DefaultSettingsSection({
  platform,
  advancedSettings,
  loading,
  selectedDefaultSettings,
  setSelectedDefaultSettings,
}) {
  const fieldData = advancedSettings?.fieldData || {};
  const requiredField = advancedSettings?.requiredField;

  const renderableFields = Object.keys(fieldData).filter(
    (key) => Array.isArray(fieldData[key]) && fieldData[key].length > 0,
  );

  if (loading) return <LoadingComponent loading={true} />;

  if (!renderableFields.length) {
    return (
      <p
        className="text-center py-3 mb-0"
        style={{ color: "rgba(255,255,255,0.3)", fontSize: 14 }}
      >
        No configurable default settings available.
      </p>
    );
  }

  return (
    <div className="row">
      {renderableFields.map((fieldName) => {
        const options = fieldData[fieldName];

        const isSingleSelect =
          NON_ARRAY_FIELDS.has(fieldName) ||
          (platform === PLATFORMS.GITHUB && fieldName === "assignee");

        const fieldValue = selectedDefaultSettings[fieldName];
        const selectedKey = fieldValue?.key || "";
        const selectedKeys = Array.isArray(fieldValue)
          ? fieldValue.map((item) => item.key)
          : fieldValue?.key
            ? [fieldValue.key]
            : [];

        const handleSingleChange = (key) => {
          const matchedOption = options.find((o) => o.key === key);
          setSelectedDefaultSettings((prev) => ({
            ...prev,
            [fieldName]: matchedOption
              ? { key: matchedOption.key, value: matchedOption.value }
              : {},
          }));
        };

        return (
          <div className="col-md-6 mb-3" key={fieldName}>
            <label className="form-label ws-label">
              {fieldName}{" "}
              {requiredField && fieldName === requiredField ? (
                <span className="text-danger fs-9">*</span>
              ) : (
                <span className="text-muted">(optional)</span>
              )}
            </label>

            {isSingleSelect ? (
              <Select
                options={options.map((o) => ({ value: o.key, label: o.value }))}
                value={
                  selectedKey
                    ? {
                        value: selectedKey,
                        label: options.find((o) => o.key === selectedKey)?.value,
                      }
                    : null
                }
                onChange={(selected) =>
                  handleSingleChange(selected ? selected.value : "")
                }
                placeholder={`— Select ${fieldName} —`}
                classNamePrefix="react-select"
                isClearable
                components={{
                  DropdownIndicator: () => null,
                  IndicatorSeparator: () => null,
                  ClearIndicator: () => null,
                  IndicatorsContainer: () => null,
                }}
              />
            ) : (
              <MultiSelect
                options={options.map((o) => ({ value: o.key, label: o.value }))}
                value={selectedKeys}
                onChange={(selectedKeys) => {
                  const selectedOptions = options.filter((o) =>
                    selectedKeys.includes(o.key),
                  );
                  setSelectedDefaultSettings((prev) => ({
                    ...prev,
                    [fieldName]: selectedOptions.map((option) => ({
                      key: option.key,
                      value: option.value,
                    })),
                  }));
                }}
              />
            )}
          </div>
        );
      })}
    </div>
  );
}